import { render, staticRenderFns } from "./PrizesInfo.vue?vue&type=template&id=edf255b0&scoped=true"
import script from "./PrizesInfo.vue?vue&type=script&lang=js"
export * from "./PrizesInfo.vue?vue&type=script&lang=js"
import style0 from "./PrizesInfo.vue?vue&type=style&index=0&id=edf255b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf255b0",
  null
  
)

export default component.exports